// 📂 components/Client/Table/ModuleDetailPanel/ModuleHeaderControls.tsx
import React from 'react';
import SimpleSelect from '../../../Forms/Input/SimpleSelect';
import TableCheckbox from '../../../Forms/Input/TableCheckbox';
import { useModule } from '../../../../hooks/module/useModule';

const ModuleHeaderControls: React.FC = () => {
  const {
    moduleDetail,
    updateFieldLocally, // 🔹 nuevo: actualiza Redux localmente
    updateModuleOrder, // 🔹 sincroniza con backend
    toggleModuleStatus, // 🔹 sincroniza con backend
  } = useModule();

  // 🕓 Mostrar estado de carga si no hay módulo
  if (!moduleDetail) {
    return (
      <div className="text-gray-500 dark:text-gray-300 flex justify-center py-4">
        Cargando módulo...
      </div>
    );
  }

  // 🔹 Cambiar orden del módulo
  const handleOrderChange = (value: string | number) => {
    const newOrder = Number(value);
    if (!isNaN(newOrder)) {
      // 1️⃣ Actualiza en Redux (instantáneo)
      updateFieldLocally('orderIndex', newOrder);

      // 2️⃣ Envia al backend
      updateModuleOrder({
        moduleId: moduleDetail.id,
        newOrder,
      });
    }
  };

  // 🔹 Activar / Desactivar módulo
  const handleToggleStatus = () => {
    const newDisabledState = !moduleDetail.disabled;

    // 1️⃣ Actualiza en Redux inmediatamente
    updateFieldLocally('disabled', newDisabledState);

    // 2️⃣ Envia al backend
    toggleModuleStatus({
      moduleId: moduleDetail.id,
      disabled: newDisabledState,
    });
  };

  return (
    <div className="mb-4 flex items-center justify-between">
      {/* 🔹 Nombre del módulo */}
      <h3 className="text-lg font-semibold text-indigo-600">
        {moduleDetail.name || 'Sin nombre'}
      </h3>

      <div className="flex items-center gap-6">
        {/* 🔹 Selector de orden */}
        <SimpleSelect
          value={moduleDetail.orderIndex}
          options={Array.from({ length: 30 }, (_, i) => i + 1)}
          onChange={handleOrderChange}
          className="min-w-[12rem] sm:min-w-[14rem] md:min-w-[16rem] lg:min-w-[18rem]"
        />

        {/* 🔹 Checkbox habilitado/deshabilitado */}
        <TableCheckbox
          checked={!moduleDetail.disabled}
          onChange={handleToggleStatus}
          label="Habilitado"
        />
      </div>
    </div>
  );
};

export default ModuleHeaderControls;
